import { Button } from "@/components/ui/button";

interface MeetingErrorStateProps {
  error: string;
  onRetry: () => void;
}

export const MeetingErrorState = ({
  error,
  onRetry,
}: MeetingErrorStateProps) => {
  return (
    <div className="flex h-screen items-center justify-center bg-background p-4">
      <div className="text-center max-w-md w-full">
        <p className="text-sm sm:text-lg font-medium mb-4">
          Lỗi kết nối: {error}
        </p>
        <Button onClick={onRetry} className="w-full sm:w-auto">
          Thử lại
        </Button>
      </div>
    </div>
  );
};

